import React, { Component } from 'react';
import { connect } from 'react-redux';
import SearchCard from "../components/LabelSearch/SearchCard";
import {actions as system} from "../reducers/system";

@connect(
    state => {
        return {
            inputText: state.system.textInput
        }
    },
    dispatch => {
        return {
            setInputText: (input) => dispatch(system.setTextInput(input))
        }
    }
)
export default class LabelSearch extends Component
{
    clearInput() {
        this.props.setInputText('')
    }

    componentDidMount(nextProps, nextContext) {
        document.addEventListener('click', (event) => this.closeCard(event, this));
    }

    closeCard(event) {
        let element = document.getElementById('labelSearch');
        if(element && !element.contains(event.target)) {
            this.props.setInputText('')
        }
    }

	render() {
        const {inputText} = this.props;

		return (
			<div id='labelSearch' style={{'position': 'relative', 'width': '400px'}}>
                <div className='input-group no-border'>
                    <input type='text' className='form-control' placeholder='Search...'
                           onChange={val => this.props.setInputText(val.target.value)}
                           value={this.props.inputText}/>
                    <div className='input-group-append'>
                        <div className='input-group-text'>
                            <i className='nc-icon nc-zoom-split'/>
                        </div>
                    </div>
                </div>
                <SearchCard textInput={inputText}/>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./React/src/screens/LabelSearch.js